const MovedBanner = () => {
  return (
    <div className="w-full bg-destructive text-destructive-foreground text-center text-sm font-semibold px-4 py-2">
      This website has been moved to{" "}
      <a
        href="https://ciwebgroup.com/get-started"
        className="underline underline-offset-2"
      >
        ciwebgroup.com/get-started
      </a>
    </div>
  );
};

export default MovedBanner;
